import React from 'react';
import { Menu, Table, TableHeaderCell } from 'semantic-ui-react';
import { DataNotFound } from '../DataNotFound';
import { useTranslation } from 'react-i18next';
import ReactPaginate from 'react-paginate';
import LoadingAnimation from '../LoadingAnimation';
import PaginationCom from '../elements/PaginationCom';

const TableLayout = ({ columns, data, datanotfound, pageCount, changePage, isLoad, displayRecords, isAmount }) => {
  const { t } = useTranslation();

  return (
    <div className="col-xl-11 pt-9">
      <div className={`relative overflow-x-auto shadow-md sm:rounded-lg`} style={{ scrollbarWidth: 'thin' }}>
        {isLoad ? (
          <LoadingAnimation
            imageStyling={''}
            styling={'flex items-center py-5 align-middle justify-center space-x-2'}
          />
        ) : (
          <>
            <Table className="text-sm tableData text-left rtl:text-right">
              <Table.Header className=" text-white bg-customgreen uppercas">
                <Table.Row>
                  {columns?.map((column, index) => (
                    <Table.HeaderCell key={index} className="text-white text-center">
                      {t(`${column}`)}
                    </Table.HeaderCell>
                  ))}
                </Table.Row>
              </Table.Header>
              <Table.Body className="text-center">{displayRecords}</Table.Body>
              {isAmount && data?.amount && (
                <Table.Footer fullWidth className=" text-customgreen ">
                  <TableHeaderCell />
                  <TableHeaderCell />
                  <TableHeaderCell />
                  <TableHeaderCell className="text-center"> {t('Amount')}:</TableHeaderCell>
                  <TableHeaderCell className="p-2  font-medium">{` ${data?.amount ? data?.amount : 0} ${t('AED')}`}</TableHeaderCell>
                </Table.Footer>
              )}
            </Table>
            {datanotfound && <DataNotFound />}
          </>
        )}
      </div>
      <div className={'relative my-4 flex flex-row md:px-12 px-5 '}>
        {/* <PaginationCom pageCount={pageCount} changePage={changePage} /> */}
        <Menu pagination>
          <Menu.Item>
            <ReactPaginate
              pagination
              previousLabel={t('Previous')}
              nextLabel={t('Next')}
              pageCount={pageCount}
              onPageChange={changePage}
              containerClassName={'paginationButtons  '}
              previousLinkClassName={'previousButton'}
              nextLinkClassName={'nextButton'}
              disabledClassName={'paginationDisabled'}
              activeClassName={'paginationActive'}
            />
          </Menu.Item>
        </Menu>
      </div>
      {/* <div className={'my-4  md:px-10 px-2  '}>
        <Stack spacing={2}>
          <Pagination
            count={pageCount}
            onChange={changePage}
            size="large"
            variant="outlined"
            shape="rounded"
            sx={{
              '& .MuiPaginationItem-root': {
                fontSize: '1.5rem', // Arrow and number font size
                color: '#06703A', // Color for all items
                backgroundColor: '#ffff',
              },
              '& .MuiPaginationItem-previousNext': {
                backgroundColor: '#ffff',
               
                '&:hover': {
                  backgroundColor: '#06703A',
                  color: '#ffff',
                },
              },
            }}
            renderItem={(item) => (
              <PaginationItem
                {...item}
                slots={{
                  previous: isActive ? ArrowForwardIcon : ArrowBackIcon,
                  next: isActive ? ArrowBackIcon : ArrowForwardIcon,
                }}
              />
            )}
          />
        </Stack>
      </div> */}
    </div>
  );
};

export default TableLayout;
